import * as React from 'react';
import UrlsService from '../../../common/router/services/urlsService.mdl';
import ScheduleReports from '../list/view/ScheduleReports';
import ScheduleReportEdit from '../item/edit/view/ScheduleReportEdit';
import ScheduleReportCreate from '../item/create/view/ScheduleReportCreate';
import {Route} from "react-router-dom";

const ScheduleReportsRouting = (
    <React.Fragment>
        <Route path={UrlsService.scheduleReports()} element={<ScheduleReports/>}/>
        <Route path={UrlsService.editScheduleReport()} element={<ScheduleReportEdit/>}/>
        <Route path={UrlsService.createScheduleReport()} element={<ScheduleReportCreate/>}/>
    </React.Fragment>
);

export default ScheduleReportsRouting;
